export default {
  layout: 'main',
  auth: true,
  availableName: 'isAdminPanel'
}
